import { GROUP_PERSON_DETAIL, DELETE_PERSON_DISTRIBUTOR } from "../constants/action-types";

export const getPersonDetail = data => ({
  type: GROUP_PERSON_DETAIL,
  payload: data
});
export const deleteMailList = data => ({
  type: DELETE_PERSON_DISTRIBUTOR,
  payload: data
});